import type { Epicycle } from "../math/epicycles";
import { fourierConfig as config } from "../config";

/** A small close-up of the moving circles, fitted to the available panel. */
export const CircleDetailInset = ({
  chain,
  y,
  opacity = 1,
}: {
  chain: readonly Epicycle[];
  y: number;
  opacity?: number;
}) => {
  if (chain.length === 0) return null;

  const start = chain.length > 5 ? 3 : 0;
  const detail = chain.slice(start, start + 9);
  const minX = Math.min(...detail.map((c) => c.center.x - c.radius));
  const maxX = Math.max(...detail.map((c) => c.center.x + c.radius));
  const minY = Math.min(...detail.map((c) => c.center.y - c.radius));
  const maxY = Math.max(...detail.map((c) => c.center.y + c.radius));
  const span = Math.max(maxX - minX, maxY - minY, 0.001);
  const pad = span * 0.14;
  const viewBox = `${minX - pad} ${minY - pad} ${maxX - minX + pad * 2} ${maxY - minY + pad * 2}`;

  return (
    <g opacity={opacity}>
      <rect
        x={320}
        y={y}
        width={440}
        height={258}
        rx={20}
        fill="#101E2C"
        stroke={config.colors.circle}
        strokeWidth={2}
        strokeOpacity={0.42}
      />
      <text
        x={540}
        y={y + 38}
        textAnchor="middle"
        fontSize={21}
        fontWeight={700}
        letterSpacing={3}
        fill={config.colors.muted}
      >
        CIRCLE DETAIL
      </text>
      <svg
        x={344}
        y={y + 53}
        width={392}
        height={185}
        viewBox={viewBox}
        overflow="hidden"
      >
        {detail.map((c) => (
          <g key={c.frequency} fill="none">
            <circle
              cx={c.center.x}
              cy={c.center.y}
              r={c.radius}
              stroke={config.colors.circle}
              strokeWidth={2.5}
              vectorEffect="non-scaling-stroke"
              opacity={0.8}
            />
            <line
              x1={c.center.x}
              y1={c.center.y}
              x2={c.tip.x}
              y2={c.tip.y}
              stroke={config.colors.vector}
              strokeWidth={2.5}
              vectorEffect="non-scaling-stroke"
              opacity={0.9}
            />
          </g>
        ))}
        <circle
          cx={detail[detail.length - 1].tip.x}
          cy={detail[detail.length - 1].tip.y}
          r={Math.max(span * 0.012, 0.001)}
          fill={config.colors.trail}
        />
      </svg>
    </g>
  );
};
